module.exports = __webpack_public_path__ + "static/media/trivo_smart_banner.2491049a.png";